// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Se abre desde la ventana de pago (z-index 200) y la tarjeta (250): tiene que quedar por delante. */\n.sm-overlay.der-overlay {\n  z-index: 400;\n}\n\n.der-overlay .sm-modal {\n  max-height: 92vh;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
